module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/xlsx-3eb19.png";